<template>
    <div v-if="usePage().props.impersonating" class="flex flex-grow items-center justify-start">
        <AppButton
            icon="accounts-outline-thick"
            theme="white-outline"
            @click="useStopImpersonation().stop_impersonation"
            :text="impersonatedCustomerNumber"
            size="small"
            class="font-medium"
            v-if="isSourcingMode"
        >
        </AppButton>
        <button
            class="border rounded border-white hover:bg-white text-white hover:text-black px-3 py-1 flex items-center gap-2"
            @click="useStopImpersonation().stop_impersonation"
            v-else
        >
            <BaseSvg
                name="icon-accounts-outline-thick"
                class="w-5 h-5"
                aria-hidden="true"
            />
            <span>{{ impersonatedCustomerNumber }}</span>
        </button>
    </div>
</template>

<script setup>
import {usePage} from "@inertiajs/vue3";
import {AppButton} from "@/Components";
import { useStopImpersonation } from "@/Composables";
import { useUser } from "@/Composables";
import { computed } from "vue";

const { settings, user } = useUser();
const isSourcingMode = computed(() => settings?.value?.is_sourcing_mode);
const impersonatedCustomerNumber = computed(
    () => user.value?.team?.customer?.customer_id ?? user.value?.registration?.account_number ?? "Stop impersonation"
);
</script>
